"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ++++++++++ --------------- EXPORT : DROPDOWN : RANGE PICKER : STYLES --------------- ++++++++++ */


var _default = _defineProperty({
  rangepickerdropdown: {
    height: (0, _index.pxToEm)(56),
    minWidth: (0, _index.pxToEm)(230),
    maxWidth: (0, _index.pxToEm)(275),
    //pxToEm(255),
    position: 'relative',
    '& .placeholder': {
      width: '100%',
      height: '100%',
      fontSize: (0, _index.pxToEm)(15),
      padding: (0, _index.pxToEm)(18),
      background: _index.theme.color.light.light.swatch,
      borderRadius: (0, _index.pxToEm)(4),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: _index.theme.boxShadow.small,
      cursor: 'pointer',
      border: "".concat((0, _index.pxToEm)(2), " solid transparent"),
      transition: 'border .2s linear 0s',
      '&:hover': {
        borderColor: _index.theme.color.secondary.light.swatch
      },
      '&.active-true': {
        borderColor: _index.theme.color.primary.medium.swatch
      }
    },
    '& .name-dropdown': {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      background: _index.theme.color.light.light.swatch,
      height: 'auto',
      // maxHeight: pxToEm(385),
      width: (0, _index.pxToEm)(550),
      padding: (0, _index.pxToEm)(8),
      transition: 'all .15s',
      position: function position(props) {
        return props.alignedRight ? 'relative' : 'absolute';
      },
      zIndex: 1,
      right: 0,
      boxShadow: _index.theme.boxShadow.small,
      '&.active-false': {
        height: '0px',
        overflow: 'hidden',
        transition: 'all .15s',
        padding: 0
      },
      '& .ctas.name-date-ranges': {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignItems: 'center',
        // padding: replacePXinStringWithEM('24px 24px 0'),
        '& .button': {
          height: (0, _index.pxToEm)(40),
          width: (0, _index.pxToEm)(135),
          fontSize: (0, _index.pxToEm)(12),
          color: _index.theme.color.supporting.light.contrast,
          background: _index.theme.color.neutral.xlight.swatch,
          border: 'none',
          padding: 0,
          margin: "".concat((0, _index.pxToEm)(16), " ").concat((0, _index.pxToEm)(20), " ").concat((0, _index.pxToEm)(16), " ").concat((0, _index.pxToEm)(20)),
          '&:last-child': {
            marginRight: '0'
          }
        },
        '& .link': {
          fontSize: (0, _index.pxToEm)(14)
        }
      },
      '& .ctas.name-date-ranges.hide-true': {
        display: 'none'
      },
      '& .datepicker': {
        paddingTop: (0, _index.pxToEm)(24),
        '& .DayPicker-Months': {
          flexWrap: 'wrap'
        }
      },
      '& .ctas.name-clear-apply': {
        width: '100%',
        justifyContent: 'space-between',
        padding: " 0 ".concat((0, _index.pxToEm)(20), " ").concat((0, _index.pxToEm)(20), " ").concat((0, _index.pxToEm)(20))
      },
      '& .ctas.name-clear-apply.hide-true': {
        display: 'none'
      }
    },
    '& .dropdownindicator': {
      // maxWidth: pxToEm(240),
      '& .title': {
        // maxWidth: pxToEm(132),
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }
  }
}, _index.mediaQuery.thinnest, {
  rangepickerdropdown: {
    '& .name-dropdown': {
      width: '100%',
      '& .ctas.name-date-ranges': {
        '& .button': {
          width: '100%',
          marginBottom: (0, _index.pxToEm)(10),
          '&:last-child': {
            marginBottom: '0'
          }
        }
      }
    }
  }
});

exports.default = _default;